import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
//UI
import {
  Input,
  SearchInput,
  Select,
  Textarea,
} from "../../../../ui/inputs/Input";
import { DangerButton, PrimaryButton, SuccessButton, WarningButton } from "../../../../ui/buttons/Button";
import useTable from "../../../../components/useTable";

const headCells = [
  {
    id: "nombres",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nombres",
    textAlign: "center",
  },
  {
    id: "apellidos",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Apellidos",
    textAlign: "center",
  },
];

export default function Organizacion({ show, setShow, setTabla }) {

  const [tableData, setTableData] = useState([]);
    const [filterFn, setFilterFn] = useState({
      fn: (items) => {
        return items;
      },
    });
  
    const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
      tableData,
      headCells,
      filterFn
    );

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="xl" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Organización</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <nav>
          <div className="nav nav-tabs mb-2" id="nav-tab" role="tablist">
            <button
              className="nav-link active"
              id="nav-datosGenerales-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-datosGenerales"
              type="button"
              role="tab"
              aria-controls="nav-datosGenerales"
              aria-selected="true"
            >
              Datos Generales
            </button>
            <button
              className="nav-link"
              id="nav-responsable-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-responsable"
              type="button"
              role="tab"
              aria-controls="nav-responsable"
              aria-selected="false"
            >
              Responsable
            </button>
            <button
              className="nav-link"
              id="nav-personalDirectivo-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-personalDirectivo"
              type="button"
              role="tab"
              aria-controls="nav-personalDirectivo"
              aria-selected="false"
            >
              Personal Directivo
            </button>
            <button
              className="nav-link"
              id="nav-contraloria-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-contraloria"
              type="button"
              role="tab"
              aria-controls="nav-contraloria"
              aria-selected="false"
            >
              Contraloría
            </button>
            <button
              className="nav-link"
              id="nav-consejoMunicipal-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-consejoMunicipal"
              type="button"
              role="tab"
              aria-controls="nav-consejoMunicipal"
              aria-selected="false"
            >
              Consejo Municipal
            </button>
            <button
              className="nav-link"
              id="nav-consejoLocalPlanificacion-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-consejoLocalPlanificacion"
              type="button"
              role="tab"
              aria-controls="nav-consejoLocalPlanificacion"
              aria-selected="false"
            >
              Consejo Local de Planificación
            </button>
          </div>
        </nav>
        <div className="tab-content" id="nav-tabContent">
          <div
            className="tab-pane fade show active"
            id="nav-datosGenerales"
            role="tabpanel"
            aria-labelledby="nav-datosGenerales-tab"
            tabindex="0"
          >
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <div className="col-3 m-0 mb-2 p-0">
                <Input label="Código:" />
              </div>
              <div className="col-9 m-0 mb-2 p-0 pl-2">
                <Input label="Razón Social:" />
              </div>
              <div className="col-9 m-0 mb-2 p-0">
                <Input label="Nombre:" />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label="RIF:" />
              </div>
              <div className="col-9 m-0 mb-2 p-0">
                <Textarea label="Domicilio:" style={{ height: 70 }} />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label="Código Presupuestario:" />
              </div>
              <div className="col-4 m-0 mb-2 p-0">
                <Select label="Estado:"></Select>
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Select label="Municipio:"></Select>
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Select label="Ciudad:"></Select>
              </div>
              <div className="col-3 m-0 mb-2 p-0">
                <Input label="Email:" />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label="Teléfono:" />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label="Celular:" />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label="Fax:" />
              </div>
              <div className="col-6 m-0 mb-2 p-0">
                <Input label="Página Web:" />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2">
                <Input label="Principios:" />
              </div>
              <div className="col-6 m-0 mb-2 p-0">
                <Textarea label="Misión:" style={{ height: 70 }} />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2">
                <Textarea label="Visión:" style={{ height: 70 }} />
              </div>
              <div className="col-6 m-0 mb-2 p-0">
                <Textarea label="Base Legal:" style={{ height: 70 }} />
              </div>
              <div className="col-2 m-0 mb-2 p-0 pl-2">
                <Input label="Código Postal:" />
              </div>
              <div className="col-12 m-0 p-0 d-flex gap-2">
                <div className="col-2 m-0 p-0">
                  <SearchInput label="Código:" />
                </div>
                <Input label="Proveedor/Beneficiario:" />
                <div className="col-2 m-0 p-0">
                  <Input label="CI/RIF:" />
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="nav-responsable"
            role="tabpanel"
            aria-labelledby="nav-responsable-tab"
            tabindex="0"
          >
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <div className="col-12 m-0 p-0">
                <div className="col-3 m-0 mb-2 p-0">
                  <SearchInput label="Cedula:" />
                </div>
              </div>
              <div className="col-6 m-0 mb-2 p-0">
                <Input label="Nombres:" />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2">
                <Input label="Apellidos:" />
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Textarea label="Dirección:" style={{ height: 70 }} />
              </div>
              <div className="col-3 m-0 mb-2 p-0">
                <Input label="Correo Electrónico:" />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label="Teléfono:" />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label="Celular:" />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label="Fecha de Nacimiento:" type="date" />
              </div>
              <div className="col-2 m-0 p-0 pr-2">
                <Select label="Nacionalidad:"></Select>
              </div>
              <div className="col-1 m-0 p-0">
                <Select label="Sexo:">
                  <option value="1">M</option>
                  <option value="2">F</option>
                </Select>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="nav-personalDirectivo"
            role="tabpanel"
            aria-labelledby="nav-personalDirectivo-tab"
            tabindex="0"
          >
            <nav>
              <div className="nav nav-tabs mb-2" id="nav-tab" role="tablist">
                <button
                  className="nav-link active"
                  id="nav-planificacionPresupuesto-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-planificacionPresupuesto"
                  type="button"
                  role="tab"
                  aria-controls="nav-planificacionPresupuesto"
                  aria-selected="true"
                >
                  Planificacion y/o Presupuesto
                </button>
                <button
                  className="nav-link"
                  id="nav-administracion-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-administracion"
                  type="button"
                  role="tab"
                  aria-controls="nav-administracion"
                  aria-selected="false"
                >
                  Administración
                </button>
                <button
                  className="nav-link"
                  id="nav-recursosHumanos-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-recursosHumanos"
                  type="button"
                  role="tab"
                  aria-controls="nav-recursosHumanos"
                  aria-selected="false"
                >
                  Recursos Humanos
                </button>
                <button
                  className="nav-link"
                  id="nav-sindicatura-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-sindicatura"
                  type="button"
                  role="tab"
                  aria-controls="nav-sindicatura"
                  aria-selected="false"
                >
                  Sindicatura
                </button>
                <button
                  className="nav-link"
                  id="nav-cronistaMunicipio-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-cronistaMunicipio"
                  type="button"
                  role="tab"
                  aria-controls="nav-cronistaMunicipio"
                  aria-selected="false"
                >
                  Cronista del Municipio
                </button>
              </div>
            </nav>
            <div className="tab-content" id="nav-tabContent">
              <div
                className="tab-pane fade show active"
                id="nav-planificacionPresupuesto"
                role="tabpanel"
                aria-labelledby="nav-planificacionPresupuesto-tab"
                tabindex="0"
              >
                <div className="col-12 m-0 p-0 d-flex flex-wrap">
                  <div className="col-12 m-0 p-0">
                    <div className="col-3 m-0 mb-2 p-0">
                      <SearchInput label="Cedula:" />
                    </div>
                  </div>
                  <div className="col-6 m-0 mb-2 p-0">
                    <Input label="Nombres:" />
                  </div>
                  <div className="col-6 m-0 mb-2 p-0 pl-2">
                    <Input label="Apellidos:" />
                  </div>
                  <div className="col-12 m-0 mb-2 p-0">
                    <Textarea label="Dirección:" style={{ height: 70 }} />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0">
                    <Input label="Correo Electrónico:" />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0 pl-2">
                    <Input label="Teléfono:" />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0 pl-2">
                    <Input label="Celular:" />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0 pl-2">
                    <Input label="Fecha de Nacimiento:" type="date" />
                  </div>
                  <div className="col-2 m-0 p-0 pr-2">
                    <Select label="Nacionalidad:"></Select>
                  </div>
                  <div className="col-1 m-0 p-0">
                    <Select label="Sexo:">
                      <option value="1">M</option>
                      <option value="2">F</option>
                    </Select>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="nav-administracion"
                role="tabpanel"
                aria-labelledby="nav-administracion-tab"
                tabindex="0"
              >
                <div className="col-12 m-0 p-0 d-flex flex-wrap">
                  <div className="col-12 m-0 p-0">
                    <div className="col-3 m-0 mb-2 p-0">
                      <SearchInput label="Cedula:" />
                    </div>
                  </div>
                  <div className="col-6 m-0 mb-2 p-0">
                    <Input label="Nombres:" />
                  </div>
                  <div className="col-6 m-0 mb-2 p-0 pl-2">
                    <Input label="Apellidos:" />
                  </div>
                  <div className="col-12 m-0 mb-2 p-0">
                    <Textarea label="Dirección:" style={{ height: 70 }} />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0">
                    <Input label="Correo Electrónico:" />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0 pl-2">
                    <Input label="Teléfono:" />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0 pl-2">
                    <Input label="Celular:" />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0 pl-2">
                    <Input label="Fecha de Nacimiento:" type="date" />
                  </div>
                  <div className="col-2 m-0 p-0 pr-2">
                    <Select label="Nacionalidad:"></Select>
                  </div>
                  <div className="col-1 m-0 p-0">
                    <Select label="Sexo:">
                      <option value="1">M</option>
                      <option value="2">F</option>
                    </Select>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="nav-recursosHumanos"
                role="tabpanel"
                aria-labelledby="nav-recursosHumanos-tab"
                tabindex="0"
              >
                ...
              </div>
              <div
                className="tab-pane fade"
                id="nav-sindicatura"
                role="tabpanel"
                aria-labelledby="nav-sindicatura-tab"
                tabindex="0"
              >
                <div className="col-12 m-0 p-0 d-flex flex-wrap">
                  <div className="col-12 m-0 p-0">
                    <div className="col-3 m-0 mb-2 p-0">
                      <SearchInput label="Cedula:" />
                    </div>
                  </div>
                  <div className="col-6 m-0 mb-2 p-0">
                    <Input label="Nombres:" />
                  </div>
                  <div className="col-6 m-0 mb-2 p-0 pl-2">
                    <Input label="Apellidos:" />
                  </div>
                  <div className="col-12 m-0 mb-2 p-0">
                    <Textarea label="Dirección:" style={{ height: 70 }} />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0">
                    <Input label="Correo Electrónico:" />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0 pl-2">
                    <Input label="Teléfono:" />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0 pl-2">
                    <Input label="Celular:" />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0 pl-2">
                    <Input label="Fecha de Nacimiento:" type="date" />
                  </div>
                  <div className="col-2 m-0 p-0 pr-2">
                    <Select label="Nacionalidad:"></Select>
                  </div>
                  <div className="col-1 m-0 p-0">
                    <Select label="Sexo:">
                      <option value="1">M</option>
                      <option value="2">F</option>
                    </Select>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="nav-cronistaMunicipio"
                role="tabpanel"
                aria-labelledby="nav-cronistaMunicipio-tab"
                tabindex="0"
              >
                <div className="col-12 m-0 p-0 d-flex flex-wrap">
                  <div className="col-12 m-0 p-0">
                    <div className="col-3 m-0 mb-2 p-0">
                      <SearchInput label="Cedula:" />
                    </div>
                  </div>
                  <div className="col-6 m-0 mb-2 p-0">
                    <Input label="Nombres:" />
                  </div>
                  <div className="col-6 m-0 mb-2 p-0 pl-2">
                    <Input label="Apellidos:" />
                  </div>
                  <div className="col-12 m-0 mb-2 p-0">
                    <Textarea label="Dirección:" style={{ height: 70 }} />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0">
                    <Input label="Correo Electrónico:" />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0 pl-2">
                    <Input label="Teléfono:" />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0 pl-2">
                    <Input label="Celular:" />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0 pl-2">
                    <Input label="Fecha de Nacimiento:" type="date" />
                  </div>
                  <div className="col-2 m-0 p-0 pr-2">
                    <Select label="Nacionalidad:"></Select>
                  </div>
                  <div className="col-1 m-0 p-0">
                    <Select label="Sexo:">
                      <option value="1">M</option>
                      <option value="2">F</option>
                    </Select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="nav-contraloria"
            role="tabpanel"
            aria-labelledby="nav-contraloria-tab"
            tabindex="0"
          >
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <div className="col-6 m-0 mb-2 p-0">
                <Input label = 'Nombres Controlador:' />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2">
                <Input label = 'Apellidos Controlador:' />
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Textarea label = 'Domicilio Legal:' style={{ height: 70 }} />
              </div>
              <div className="col-3 m-0 p-0">
                <Input label = 'Correo Electrónico:' />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label = 'Teléfono:' />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label = 'Fax:' />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label = 'Página Web:' />
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="nav-consejoMunicipal"
            role="tabpanel"
            aria-labelledby="nav-consejoMunicipal-tab"
            tabindex="0"
          >
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <div className="col-6 m-0 mb-2 p-0">
                <Input label = 'Nombres Presidente:' />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2">
                <Input label = 'Apellidos Presidente:' />
              </div>
              <div className="col-6 m-0 mb-2 p-0">
                <Input label = 'Nombres Secretario:' />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2">
                <Input label = 'Apellidos Secretario:' />
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Textarea label = 'Domicilio Legal:' style={{ height: 70 }} />
              </div>
              <div className="col-3 m-0 p-0">
                <Input label = 'Correo Electrónico:' />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label = 'Teléfono:' />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label = 'Fax:' />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label = 'Página Web:' />
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="nav-consejoLocalPlanificacion"
            role="tabpanel"
            aria-labelledby="nav-consejoLocalPlanificacion-tab"
            tabindex="0"
          >
            <div className="col-12 m-0 p-0 d-flex">
              <div className="col-11 m-0 p-0">
              <TblContainer>
            <TblHead />
            <tbody>
              {tableData &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr key={index}></tr>
                ))}
            </tbody>
          </TblContainer>
              </div>
              <div className="col-1 m-0 p-0 d-flex flex-column gap-2 align-items-center justify-content-center">
                <div className="col-auto m-0 p-0">
                  <PrimaryButton icon="fa-plus m-0" />
                </div>
                <div className="col-auto m-0 p-0">
                  <WarningButton icon="fa-edit m-0" />
                </div>
                <div className="col-auto m-0 p-0">
                  <DangerButton icon="fa-trash-alt m-0" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton>Aceptar</SuccessButton>
        <DangerButton>Cancelar</DangerButton>
      </Modal.Footer>
    </Modal>
  );
}
